// @ts-ignore
import { CommonModule } from '@angular/common';
// @ts-ignore
import { Component, inject, signal } from '@angular/core';
// @ts-ignore
import { FormsModule } from '@angular/forms';
// @ts-ignore
import { Observable } from 'rxjs';
import { CotacaoPayload, SankhyaGatewayService } from '../../services/sankhya-gateway.service';
import { HomeLogoAnimationService } from '../../services/home-logo-animation.service';

// @ts-ignore
@Component({
  selector: 'app-home',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './home.component.html',
  styleUrl: './home.component.css'
})
export class HomeComponent {
  readonly homeLogoSrc = inject(HomeLogoAnimationService).takeHomeLogoSource();

  codprod = '20140';
  loading = signal(false);
  lastAction = signal('Pronto');
  response = signal('A resposta do gateway aparece aqui.');

  cotacao: CotacaoPayload = {
    CODPROD: '20140',
    FORNEC: 'AERO RADIO',
    PRECO: '31.00',
    VARIACAO: '1.50',
    CORE: '0.00',
    LUCRO: '38',
    CUSTO: '28',
    PRECOVENDA: '54.76',
    REFFORN: '010-11654-03',
    DESCRPROD: 'ACUMULADOR GPS AERA660',
    CODVOL: 'UN',
    TEMSERIE: 'NAO',
    TEMCORE: 'NAO',
    MARCA: 'GARMIN',
    CONDICAO: 'NEW',
    OBSTECNICA: '',
    OBSINTERNA: ''
  };

  constructor(private readonly sankhyaGateway: SankhyaGatewayService) {}

  listar(): void {
    this.run('Listar cotacao', () => this.sankhyaGateway.listarCotacaoProduto(this.codprod));
  }

  salvar(): void {
    this.cotacao.CODPROD = this.codprod;
    this.run('Salvar cotacao', () => this.sankhyaGateway.salvarCotacao(this.cotacao));
  }

  private run(action: string, request: () => Observable<unknown>): void {
    this.loading.set(true);
    this.lastAction.set(action);
    request().subscribe({
      next: (value: unknown) => {
        this.response.set(JSON.stringify(value, null, 2));
        this.loading.set(false);
      },
      error: (error: unknown) => {
        this.response.set(JSON.stringify(error, null, 2));
        this.loading.set(false);
      }
    });
  }
}
